import { useSyncExternalStore, useState } from "react";
import {
  getSaveState,
  ownerStorage,
  subscribeSaveState,
} from "../lib/privacy/ownerStorage";
import { useAuth } from "../context/AuthContext";
export function SaveStatus() {
  const status = useSyncExternalStore(
    subscribeSaveState,
    getSaveState,
    getSaveState,
  );
  const { syncStatus, signOut, status: authStatus } = useAuth();
  const [message, setMessage] = useState("");
  const original = ownerStorage.getItem("recovery-original");
  const exportRecovery = (originalCopy = false) => {
    const data =
      (originalCopy
        ? original
        : ownerStorage.getItem("resilience_forge_app_state")) || "{}";
    const url = URL.createObjectURL(
      new Blob([data], { type: "application/json" }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.download = "resilience-forge-recovery.json";
    link.click();
    URL.revokeObjectURL(url);
  };
  return (
    <aside className="save-status" aria-label="Saving and session controls">
      <span role="status" className="save-label">
        {status === "error"
          ? "Save failed. Your work is in memory; export before leaving."
          : status === "session"
            ? "Saved in this tab"
            : "Saved on this device"}
        {syncStatus === "pending"
          ? " · Cloud backup pending"
          : syncStatus === "error"
            ? " · Cloud backup failed"
            : syncStatus === "synced"
              ? " · Last queued changes backed up"
              : " · Cloud backup off"}
      </span>
      {status === "error" && (
        <button onClick={() => exportRecovery()}>Export recovery copy</button>
      )}
      {original && (
        <span role="alert">
          An earlier save could not be read.{" "}
          <button onClick={() => exportRecovery(true)}>
            Export original save
          </button>
        </span>
      )}
      {authStatus === "offline" && (
        <span>
          Account verification unavailable. Local account data is open; cloud
          and privileged features are off.
        </span>
      )}
      <details className="session-controls"><summary>Session options</summary><p>People using this open tab can see your practice. Export anything you want to keep before ending a guest session.</p><button onClick={() => exportRecovery()}>Export practice copy</button>
      <button
        onClick={() =>
          void signOut().catch((error) =>
            setMessage(
              error instanceof Error ? error.message : "Session ended.",
            ),
          )
        }
      >
        End this session
      </button>
      </details>
      {message && <p role="alert">{message}</p>}
    </aside>
  );
}
